import { Component, input, output, signal, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { MatCard, MatCardHeader, MatCardTitle, MatCardActions } from '@angular/material/card';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelTitle } from '@angular/material/expansion';
import { RouterLink } from '@angular/router';

// import { MatBottomSheet } from '@angular/material/bottom-sheet';
// import { PurchaseSheetComponent } from '../purchase-sheet/purchase-sheet.component';


// Define an interface for video data, consistent with app.component.ts
interface Video {
  id: number;
  priceID: string;
  item_CODE: string;
  title: string;
  amount: string;
  thumbnailUrl: string;
  videoUrl: string;
  description: string;
  hasPermission: boolean;
}

@Component({
    selector: 'app-videolist',
    templateUrl: './videolist.component.html',
    styleUrls: ['./videolist.component.css'],
    imports: [MatCard, MatCardHeader, MatCardTitle, MatButton, MatIcon, MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelTitle, RouterLink, MatCardActions]
})
export class VideoListComponent {
  private http = inject(HttpClient);

  // Signal inputs
  videos = input<Video[]>([]);
  isLoggedIn = input<boolean>(false);

  // Signal output
  videoSelected = output<Video>();

  // Signal state
  isLoading = signal(false);
  isInitiatingCheckout = signal(false);
  purchaseMessage = signal('');
  purchaseError = signal('');
  enabled = signal(false);

  colors = ['#00A2E8', '#3F48CC', '#D5373C', '#22B14C'];

  /**
   * Emits the selected video to the parent component.
   * @param video The video object to be played.
   */
  onSelectVideo(video: Video): void {

    //test if logged in and has permission to view the video

    this.videoSelected.emit(video);

    
  }

  onPurchase(priceID: string): void {

    //get stripe priceID for the video product
    //then initiate checkout_session with that priceID

    // send priceID of video product
    this.initiateCheckout(priceID, 'payment');

  }

  async initiateCheckout(priceId: string, mode: 'payment') {
    this.isInitiatingCheckout.set(true);
    this.http.post<{ sessionId: string, stripeKey: string, sessionUrl: string }>('api/create-checkout-session/create-checkout-session.php', { priceId, mode }).subscribe({
      next: async (response) => {
        // Redirect to Stripe Checkout
        window.location.assign(response.sessionUrl); // Redirect to Checkout
      },
      error: (error) => {
        this.isInitiatingCheckout.set(false);
        console.error('Error creating checkout session:', error);
      }
    });
  }

}